import './i18n';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Routes instead of Switch
import { SdfBusyIndicator } from "@waypoint/react-components";
import { SessionContext, SessionProvider } from "./components/session";
import { ApplicationStateProvider } from "./utilities/applicationState";
import { AppConfigProvider } from "./utilities/appConfig";
import OneUxLayout from "./components/oneux-layout";
import Login from "./components/login/login";
import { NotificationProvider } from "./components/shared/notifications";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./App.scss";
import { getEnvRootPath } from "./components/common/util";

export default function App() {
  return (
    <ApplicationStateProvider>
      <AppConfigProvider>
        <SessionProvider>
          <SessionContext.Consumer>
            {(session) => {
              if (session.state === "LOADING") {
                return (
                  <div className="app-load">
                    <SdfBusyIndicator
                      style={{ color: "#1a8099" }}
                      size="xl"
                      fullScreen={true}
                    ></SdfBusyIndicator>
                  </div>
                );
              } else {
                return (
                  <Router
                    basename={`${getEnvRootPath()}`}
                    future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
                  >
                    <div id="app" className="app">
                      <Routes>
                        <Route path="/login" element={<Login />} /> {/* element prop instead of component */}
                        <Route path="/*" element={
                          <NotificationProvider>
                            <OneUxLayout />
                          </NotificationProvider>
                        } />
                      </Routes>
                    </div>
                  </Router>
                );
              }
            }}
          </SessionContext.Consumer>
        </SessionProvider>
      </AppConfigProvider>
    </ApplicationStateProvider>
  );
}
